var _metadata, _sodipodiNamedview, _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    id: "svg48",
    sodipodiDocname: "tile.svg",
    inkscapeVersion: "1.0.2-2 (e86c870879, 2021-01-15)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata52"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1267,
    "inkscapeWindow-height": 967,
    id: "namedview50",
    showgrid: "false",
    inkscapeZoom: 16.366053,
    inkscapeCx: 22.5,
    inkscapeCy: 22.5,
    inkscapeWindowX: 104,
    inkscapeWindowY: 44,
    inkscapeWindowMaximized: 0,
    inkscapeCurrentLayer: "svg48"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title32"
  }, "Sign out") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title32"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc34"
  }, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs36"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "bakgrunnur",
    fill: "#ffffff",
    opacity: 0.2,
    x: 0,
    y: 0,
    width: 45,
    height: 45,
    rx: 15,
    style: {
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTile);
export default __webpack_public_path__ + "static/media/tile.823dca680c6cdbc96953603c19f1c12e.svg";
export { ForwardRef as ReactComponent };